import userFriendlyEr               from "../../utils/userFriendlyEr";
import url                          from '../../utils/url.js'
import router                       from '@/routes'
import { ICON_TYPE_ROUTE_NAME_MAP } from '@/config/map'

export default {
  data () {
    return {
      markerPopup: {},
      head: null,
      rows: {},
      fields: {},
      loading: true,
      error: null,
      showMore: false,
    }
  },
  created() {
    this.showMore = !this.$sharedServices.store.getters.isGuest
  },
  destroyed () {
    if (this.destroySubs) {
      this.destroySubs.unsubscribe()
    }
  },
  computed: {
    iconTypeRouteNameMap () {
      return ICON_TYPE_ROUTE_NAME_MAP
    }
  },
  methods: {
    more () {
      const type = this?.subLayerConfig?.iconType || this?.markerModel?.type
      const name = this?.subLayerConfig?.routeName && this?.subLayerConfig?.routeName(this.fields) ||
        this.iconTypeRouteNameMap[type]
      if (!name) {
        console.error(`Не найден роут для типа ${type}. Проверьте iconTypeRouteNameMap и/или добавьте туда этот тип`)
        return
      }
    
      const prevRoute = url.getRoute(router.history.current, true)
      router.push({ name, params: {id: this?.id || this?.fields?.id}, query: { prevRoute } })
    },
    registerVueInMap () {
      this.destroySubs = this.$emitter.listen('geo.destroyMap', () => {
        this.$destroy()
      })
    },
    fetchGeoObjectPopupData (endpoint) {
      this.loading = true
      this.error = null
      this.$sharedServices.store.dispatch('updateUrlEndpoint', {
        endpoint: endpoint,
        params: {
          disableGlobalError: true
        }
      }).then(r => {
        this.rows = Object.assign({}, r.data.fields)
        this.head = r.data.head
        this.fields = r.data.model
        console.log(r)
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.error = userFriendlyEr.recognize(e)
      })
    }
  }
}
